import { INVOICE_NO_PREFIX } from "_constants";

export const invoiceNumber = (invoiceNo) => {
  return `${INVOICE_NO_PREFIX}-${invoiceNo}`;
};
